/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    /* JS FOR PRODUCT IMAGE SLIDER */

document.addEventListener("DOMContentLoaded", function () {
  // Only run on mobile
  if (window.innerWidth > 768) return;

  const sliderWrapper = document.querySelector('product-images.product__images--mobile-slider');
  if (!sliderWrapper) return;

  const scrollContainer = sliderWrapper.querySelector('.product__slides');
  if (!scrollContainer) return;

  // Inject progress bar if it doesn't exist
  if (!sliderWrapper.nextElementSibling?.classList?.contains('mobile-slider-progress')) {
    const progressBarWrapper = document.createElement('div');
    progressBarWrapper.className = 'mobile-slider-progress';
    progressBarWrapper.innerHTML = '<div class="mobile-slider-progress__bar"></div>';
    sliderWrapper.insertAdjacentElement('afterend', progressBarWrapper);
  }

  const progressBar = document.querySelector('.mobile-slider-progress__bar');

  function updateProgressBar() {
    const scrollLeft = scrollContainer.scrollLeft;
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    const percent = (scrollLeft / maxScroll) * 100;
    progressBar.style.width = `${percent}%`;
  }

  scrollContainer.addEventListener('scroll', updateProgressBar, { passive: true });
  updateProgressBar();
});

document.addEventListener('DOMContentLoaded', function() {
  function updateClocks() {
    const options = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };

    const nyElement = document.getElementById('time-ny');
    const lonElement = document.getElementById('time-lon');
    const sydElement = document.getElementById('time-syd');

    if (nyElement) {
      nyElement.textContent = new Date().toLocaleTimeString('en-US', { ...options, timeZone: 'America/New_York' });
    }
    if (lonElement) {
      lonElement.textContent = new Date().toLocaleTimeString('en-GB', { ...options, timeZone: 'Europe/London' });
    }
    if (sydElement) {
      sydElement.textContent = new Date().toLocaleTimeString('en-AU', { ...options, timeZone: 'Australia/Sydney' });
    }
  }

  setInterval(updateClocks, 1000);
  updateClocks();
});


// BOF HIDING AND SELECTING OPTIONS ON PRODUCT PAGE //

function autoSelectOnlyOption2(scope = document) {
  scope.querySelectorAll('.product__selectors').forEach((selectors) => {
    const option2Inputs = selectors.querySelectorAll(
      '.selector-wrapper[data-option-position="2"] input[data-index="option2"]'
    );

    if (!option2Inputs.length) return;

    const validOption2 = Array.from(option2Inputs).filter((input) => {
      return !input.classList.contains('unavailable');
    });

    if (validOption2.length === 1) {
      const onlyOption = validOption2[0];

      if (!onlyOption.checked) {
        onlyOption.checked = true;
        onlyOption.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}

function updateOption1StrikeState(scope = document) {
  scope.querySelectorAll('.product__selectors').forEach((selectors) => {
    const option2Inputs = selectors.querySelectorAll(
      '.selector-wrapper[data-option-position="2"] input[data-index="option2"]'
    );

    if (!option2Inputs.length) {
      selectors.classList.remove('option2-all-blocked');
      return;
    }

    const allBlocked = Array.from(option2Inputs).every((input) =>
      input.classList.contains('unavailable') ||
      input.classList.contains('sold-out')
    );

    selectors.classList.toggle('option2-all-blocked', allBlocked);
  });
}

function runVariantUIUpdates(scope = document) {
  requestAnimationFrame(() => {
    autoSelectOnlyOption2(scope);
    updateOption1StrikeState(scope);

    setTimeout(() => {
      autoSelectOnlyOption2(scope);
      updateOption1StrikeState(scope);
    }, 80);

    setTimeout(() => {
      autoSelectOnlyOption2(scope);
      updateOption1StrikeState(scope);
    }, 180);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product__selectors').forEach((selectors) => {
    selectors.classList.remove('variant-interacted');
  });

  runVariantUIUpdates();
});

document.addEventListener('change', (event) => {
  if (
    event.target.matches('.product__selectors input[data-index="option1"]') ||
    event.target.matches('.product__selectors input[data-index="option2"]')
  ) {
    const selectors = event.target.closest('.product__selectors');
    if (!selectors) return;

    const hasOption2 = selectors.querySelector('.selector-wrapper[data-option-position="2"]');
    if (hasOption2) {
      selectors.classList.add('variant-interacted');
    }

    runVariantUIUpdates();
  }
});





// EOF HIDING AND SELECTING OPTIONS ON PRODUCT PAGE //


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
